import React from 'react';
import styled from 'styled-components';
import { IbmplexsansMediumElectricViolet14px } from '../styledMixins';

function Frame1308(props) {
  const { date } = props;

  return (
    <Frame13081>
      <Address>{date}</Address>
    </Frame13081>
  );
}

const Frame13081 = styled.div`
  display: flex;
  width: fit-content;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 12px;
  position: relative;
  background-color: #f1e7ff;
  border-radius: 13px;
  overflow: hidden;
  border: 1px solid;
  border-color: #ce99ff;
`;

const Address = styled.div`
  ${IbmplexsansMediumElectricViolet14px}
  position: relative;
  width: fit-content;
  margin-top: -1px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
`;

const Frame13082 = styled.div`
  display: flex;
  width: fit-content;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 12px;
  position: relative;
  background-color: var(--blue-chalk);
  border-radius: 13px;
  overflow: hidden;
  border: 1px solid;
  border-color: var(--dark-mode-purple);
`;

const Address1 = styled.div`
  ${IbmplexsansMediumElectricViolet14px}
  position: relative;
  width: fit-content;
  margin-top: -1px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
`;

const Frame13083 = styled.div`
  display: flex;
  width: fit-content;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 12px;
  position: relative;
  background-color: var(--blue-chalk);
  border-radius: 13px;
  overflow: hidden;
  border: 1px solid;
  border-color: var(--dark-mode-purple);
`;

const Address2 = styled.div`
  ${IbmplexsansMediumElectricViolet14px}
  position: relative;
  width: fit-content;
  margin-top: -1px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
`;

const Frame13084 = styled.div`
  display: flex;
  width: fit-content;
  align-items: flex-start;
  gap: 10px;
  padding: 4px 12px;
  position: relative;
  background-color: var(--blue-chalk);
  border-radius: 13px;
  overflow: hidden;
  border: 1px solid;
  border-color: var(--dark-mode-purple);
`;

const Address3 = styled.div`
  ${IbmplexsansMediumElectricViolet14px}
  position: relative;
  width: fit-content;
  margin-top: -1px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
`;

export default Frame1308;
